import React from "react";

import { dateToMonth } from "../../lib/utils";

function BookingFormFinal({ hoteldata, finalData, datein, dateout, onClose }) {
  return (
    <div className="tac mb12">
      <h2>Поздарвляем!</h2>
      <p>
        <b>Бронирование #{finalData.id} успешно создано.</b>
      </p>
      <p>
        <b>Номер:</b> {hoteldata.room_name}
      </p>
      <p>
        <b>Даты:</b> {dateToMonth(datein)} – {dateToMonth(dateout)}
      </p>
      <p>
        <b>Стоимость:</b> {finalData.prices.total} ₽
      </p>
      {finalData?.paymentUrl ? (
        <p>
          <span className="small silver">
            Для завершения бронирования вам нужно внести оплату в размере{" "}
            {finalData.prices.need_prepayment}₽
          </span>
          <br />
          <button
            className="grayButton orange mt12"
            onClick={() => window.open(finalData.paymentUrl)}
          >
            Оплатить {finalData.prices.need_prepayment} ₽
          </button>
        </p>
      ) : (
        <p>
          <button className="grayButton" onClick={onClose}>
            OK
          </button>
        </p>
      )}
    </div>
  );
}

export default BookingFormFinal;
